import { render, staticRenderFns } from "./OpenRtbListBlockSimple.vue?vue&type=template&id=2e38cb30&scoped=true&"
import script from "./OpenRtbListBlockSimple.vue?vue&type=script&lang=js&"
export * from "./OpenRtbListBlockSimple.vue?vue&type=script&lang=js&"
import style0 from "./OpenRtbListBlockSimple.vue?vue&type=style&index=0&id=2e38cb30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38cb30",
  null
  
)

export default component.exports